/* istanbul ignore file */
import { FieldProps, TextField, useFieldHelper, NameField } from 'framework/ui/field';
import EmployeeLink from '../EmployeeLink';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';

const EmployeeLinkField = ({ source, nameSource, ...props }: FieldProps) => {
  const { getValue: getId } = useFieldHelper({ source });
  const { getValue: getName } = useFieldHelper({ source: nameSource });
  const name = getName();

  const value = (
    <EmployeeLink name={typeof name === 'string' ? name : <NameField value={name} />} id={getId()} {...props} />
  );
  const displayedValue = getId() ? value : EMPTY_VALUE_INDICATOR;

  return <TextField value={displayedValue} {...props} />;
};

export default EmployeeLinkField;
